import { extendedReviews, testimonials, type Testimonial } from '@/data/testimonials';

export type TestimonialLanguage = 'en' | 'de' | 'es' | 'fr' | 'it' | 'pt' | 'ru' | 'sv' | 'zh';

const testimonialTextTranslations: Record<number, Record<TestimonialLanguage, string>> = {
  1: {
    en: "Incredible quality! The hologram looks so realistic. Fast shipping too.",
    de: "Unglaubliche Qualität! Das Hologramm sieht so realistisch aus. Schneller Versand auch.",
    es: "¡Calidad increíble! El holograma parece muy realista. Envío rápido también.",
    fr: "Qualité incroyable ! L'hologramme a l'air si réaliste. Expédition rapide également.",
    it: "Qualità incredibile! L'ologramma sembra così realistico. Anche la spedizione veloce.",
    pt: "Qualidade incrível! O holograma parece tão realista. Envio rápido também.",
    ru: "Невероятное качество! Голограмма выглядит очень реалистично. И быстрая доставка.",
    sv: "Otrolig kvalitet! Hologrammet ser så realistiskt ut. Snabb leverans också.",
    zh: "令人难以置信的品质！全息图看起来非常逼真。发货也很快。",
  },
  2: {
    en: "Perfect for my costume party. Everyone thought it was real!",
    de: "Perfekt für meine Kostümparty. Alle dachten, es sei echt!",
    es: "Perfecto para mi fiesta de disfraces. ¡Todos pensaron que era real!",
    fr: "Parfait pour ma soirée costumée. Tout le monde pensait que c'était réel !",
    it: "Perfetto per la mia festa in costume. Tutti pensavano che fosse reale!",
    pt: "Perfeito para minha festa à fantasia. Todos pensaram que era real!",
    ru: "Идеально подходит для моей костюмированной вечеринки. Все думали, что это правда!",
    sv: "Perfekt för min kostymfest. Alla trodde att det var på riktigt!",
    zh: "非常适合我的化装舞会。每个人都认为这是真的！",
  },
  3: {
    en: "Great customer service and the card arrived in just 5 days.",
    de: "Toller Kundenservice und die Karte kam in nur 5 Tagen an.",
    es: "Excelente servicio al cliente y la tarjeta llegó en solo 5 días.",
    fr: "Excellent service client et la carte est arrivée en seulement 5 jours.",
    it: "Ottimo servizio clienti e la carta è arrivata in soli 5 giorni.",
    pt: "Ótimo atendimento e o cartão chegou em apenas 5 dias.",
    ru: "Отличное обслуживание клиентов, карта прибыла всего за 5 дней.",
    sv: "Bra kundservice och kortet kom på bara 5 dagar.",
    zh: "优质的客户服务，卡片仅 5 天就到达了。",
  },
  4: {
    en: "Exactly what I needed. The customization options are amazing.",
    de: "Genau das, was ich brauchte. Die Anpassungsmöglichkeiten sind erstaunlich.",
    es: "Exactamente lo que necesitaba. Las opciones de personalización son increíbles.",
    fr: "Exactement ce dont j'avais besoin. Les options de personnalisation sont incroyables.",
    it: "Esattamente quello di cui avevo bisogno. Le opzioni di personalizzazione sono sorprendenti.",
    pt: "Exatamente o que eu precisava. As opções de personalização são incríveis.",
    ru: "Именно то, что мне было нужно. Возможности настройки просто потрясающие.",
    sv: "Precis vad jag behövde. Anpassningsalternativen är fantastiska.",
    zh: "正是我所需要的。定制选项令人惊叹。",
  },
  5: {
    en: "Third order from this site. Never disappointed. Highly recommend!",
    de: "Dritte Bestellung von dieser Website. Nie enttäuscht. Sehr zu empfehlen!",
    es: "Tercer pedido de este sitio. Nunca decepcionado. ¡Lo recomiendo encarecidamente!",
    fr: "Troisième commande sur ce site. Jamais déçu. Je le recommande vivement !",
    it: "Terzo ordine da questo sito. Mai deluso. Lo consiglio vivamente!",
    pt: "Terceiro pedido deste site. Nunca fiquei desapontado. Altamente recomendado!",
    ru: "Третий заказ на этом сайте. Никогда не разочаровывался. Очень рекомендую!",
    sv: "Tredje beställningen från den här webbplatsen. Aldrig besviken. Rekommenderas varmt!",
    zh: "来自此网站的第三次订单。从来没有失望过。强烈推荐！",
  },
  6: {
    en: "Amazing quality and super fast delivery. The card looks absolutely authentic!",
    de: "Erstaunliche Qualität und superschnelle Lieferung. Die Karte sieht absolut authentisch aus!",
    es: "Calidad increíble y entrega súper rápida. ¡La tarjeta parece absolutamente auténtica!",
    fr: "Qualité incroyable et livraison ultra rapide. La carte a l'air absolument authentique !",
    it: "Qualità straordinaria e consegna super veloce. La carta sembra assolutamente autentica!",
    pt: "Qualidade incrível e entrega super rápida. O cartão parece absolutamente autêntico!",
    ru: "Потрясающее качество и супер быстрая доставка. Открытка выглядит абсолютно аутентично!",
    sv: "Fantastisk kvalitet och supersnabb leverans. Kortet ser helt autentiskt ut!",
    zh: "令人惊叹的品质和超快的交货。该卡看起来绝对正品！",
  },
  7: {
    en: "Really the best! The product has excellent quality, would buy it again anytime!",
    de: "Wirklich das Beste! Das Produkt hat eine hervorragende Qualität, würde es jederzeit wieder kaufen!",
    es: "¡Realmente la mejor! El producto tiene una calidad excelente, ¡lo volvería a comprar en cualquier momento!",
    fr: "Vraiment la meilleure ! Le produit est d'excellente qualité, je l'achèterais à nouveau à tout moment !",
    it: "Davvero il migliore! Il prodotto è di ottima qualità, lo comprerei di nuovo in qualsiasi momento!",
    pt: "Realmente o melhor! O produto tem excelente qualidade, compraria novamente a qualquer momento!",
    ru: "Действительно лучшая! Товар отличного качества, куплю его снова в любое время!",
    sv: "Verkligen det bästa! Produkten har utmärkt kvalitet, skulle köpa den igen när som helst!",
    zh: "真的是最好的！该产品品质优良，随时会再次购买！",
  },
  8: {
    en: "Super friendly contact, responds fast to emails. I recommend this seller 100%!",
    de: "Super freundlicher Kontakt, antwortet schnell auf E-Mails. Ich empfehle diesen Verkäufer zu 100 %!",
    es: "Contacto súper amigable, responde rápido a los correos electrónicos. ¡Recomiendo a este vendedor 100%!",
    fr: "Contact super sympathique, répond rapidement aux e-mails. Je recommande ce vendeur à 100% !",
    it: "Contatto super cordiale, risponde velocemente alle e-mail. Raccomando questo venditore al 100%!",
    pt: "Contato super amigável, responde rápido aos emails. Eu recomendo este vendedor 100%!",
    ru: "Супер дружелюбный контакт, быстро отвечает на электронные письма. Рекомендую этого продавца на 100%!",
    sv: "Supervänlig kontakt, svarar snabbt på e-postmeddelanden. Jag rekommenderar denna säljare till 100 %!",
    zh: "超级友好的联系人，快速回复电子邮件。我百分百推荐这个卖家！",
  },
  9: {
    en: "ID cards look just like real ones! Got in everywhere, super satisfied!",
    de: "Ausweise sehen genauso aus wie echte! Bin überall angekommen, super zufrieden!",
    es: "¡Las tarjetas de identificación parecen reales! Llegué a todas partes, ¡súper satisfecho!",
    fr: "Les cartes d'identité ressemblent aux vraies ! Je l'ai mis partout, super satisfait !",
    it: "Le carte d'identità sembrano proprio quelle vere! Sono arrivato ovunque, super soddisfatto!",
    pt: "Os cartões de identificação parecem reais! Entrei em todos os lugares, super satisfeito!",
    ru: "Удостоверения личности выглядят как настоящие! Везде заходил, очень доволен!",
    sv: "ID-kort ser precis ut som riktiga! Kom in överallt, supernöjd!",
    zh: "身份证看起来就像真的一样！到处都是，超级满意！",
  },
  10: {
    en: "Impeccable! Had to wait a bit longer, but it was definitely worth it!",
    de: "Einwandfrei! Musste etwas länger warten, aber es hat sich auf jeden Fall gelohnt!",
    es: "¡Impecable! Tuve que esperar un poco más, ¡pero definitivamente valió la pena!",
    fr: "Impeccable ! Il a fallu attendre un peu plus longtemps, mais cela en valait vraiment la peine !",
    it: "Impeccabile! Ho dovuto aspettare ancora un po', ma ne è valsa decisamente la pena!",
    pt: "Impecável! Tive que esperar um pouco mais, mas definitivamente valeu a pena!",
    ru: "Безупречно! Пришлось немного подождать, но оно того определенно стоило!",
    sv: "Oklanderligt! Fick vänta lite till, men det var definitivt värt det!",
    zh: "无可挑剔！不得不等待一段时间，但绝对值得！",
  },
  11: {
    en: "Really great store. Card came within two days and looks amazing. Thank you!",
    de: "Wirklich toller Laden. Die Karte kam innerhalb von zwei Tagen und sieht fantastisch aus. Vielen Dank!",
    es: "Una tienda realmente excelente. La tarjeta llegó en dos días y se ve increíble. ¡Gracias!",
    fr: "Vraiment un super magasin. La carte est arrivée dans les deux jours et a l’air incroyable. Merci !",
    it: "Negozio davvero fantastico. La carta è arrivata entro due giorni e sembra fantastica. Grazie!",
    pt: "Loja realmente ótima. O cartão chegou em dois dias e parece incrível. Obrigado!",
    ru: "Действительно отличный магазин. Карта пришла в течение двух дней и выглядит потрясающе. Спасибо!",
    sv: "Riktigt bra butik. Kortet kom inom två dagar och ser fantastiskt ut. Tack!",
    zh: "真的很棒的商店。卡片在两天内就到了，看起来棒极了。谢谢！",
  },
  12: {
    en: "I ordered two ID cards and the quality is just outstanding!",
    de: "Ich habe zwei Ausweise bestellt und die Qualität ist einfach hervorragend!",
    es: "Pedí dos tarjetas de identificación y ¡la calidad es excelente!",
    fr: "J'ai commandé deux cartes d'identité et la qualité est tout simplement exceptionnelle !",
    it: "Ho ordinato due carte d'identità e la qualità è semplicemente eccezionale!",
    pt: "Encomendei dois cartões de identificação e a qualidade é simplesmente excelente!",
    ru: "Заказывал два удостоверения личности, качество просто великолепное!",
    sv: "Jag beställde två ID-kort och kvaliteten är bara enastående!",
    zh: "我订购了两张身份证，质量非常好！",
  },
  13: {
    en: "Good quality of the ID cards. Great communication. Fast shipping. Would order again!",
    de: "Gute Qualität der Ausweise. Tolle Kommunikation. Schneller Versand. Würde wieder bestellen!",
    es: "Buena calidad de las tarjetas de identificación. Gran comunicación. Envío rápido. ¡Haría el pedido de nuevo!",
    fr: "Bonne qualité des cartes d'identité. Excellente communication. Expédition rapide. Je commanderais à nouveau !",
    it: "Buona qualità delle carte d'identità. Ottima comunicazione. Spedizione veloce. Lo ordinerei di nuovo!",
    pt: "Boa qualidade dos cartões de identificação. Ótima comunicação. Envio rápido. Pediria novamente!",
    ru: "Удостоверения личности хорошего качества. Отличное общение. Быстрая доставка. Закажу еще раз!",
    sv: "God kvalitet på ID-korten. Bra kommunikation. Snabb leverans. Skulle beställa igen!",
    zh: "身份证质量很好。很好的沟通。快速运输。会再次订购！",
  },
  14: {
    en: "Very good ID card! Super quality and excellent communication!",
    de: "Sehr guter Ausweis! Super Qualität und hervorragende Kommunikation!",
    es: "¡Muy buena tarjeta de identificación! ¡Súper calidad y excelente comunicación!",
    fr: "Très bonne carte d'identité ! Super qualité et excellente communication !",
    it: "Carta d'identità molto buona! Super qualità e comunicazione eccellente!",
    pt: "Cartão de identificação muito bom! Super qualidade e excelente comunicação!",
    ru: "Очень хорошее удостоверение личности! Супер качество и отличная связь!",
    sv: "Mycket bra ID-kort! Superkvalitet och utmärkt kommunikation!",
    zh: "很好的身份证！卓越的品质和良好的沟通！",
  },
  15: {
    en: "Great quality of the cards! They look even better than in the pictures!",
    de: "Tolle Qualität der Karten! Sie sehen noch besser aus als auf den Bildern!",
    es: "¡Gran calidad de las tarjetas! ¡Se ven incluso mejor que en las fotos!",
    fr: "Grande qualité des cartes ! Ils sont encore plus beaux que sur les photos !",
    it: "Grande qualità delle carte! Sono ancora più belli che in foto!",
    pt: "Ótima qualidade dos cartões! Eles parecem ainda melhores do que nas fotos!",
    ru: "Отличное качество открыток! Выглядят даже лучше, чем на картинках!",
    sv: "Bra kvalitet på korten! De ser ännu bättre ut än på bilderna!",
    zh: "卡片的品质非常好！它们看起来比图片还要好！",
  },
  16: {
    en: "The best you can buy online! Absolutely perfect quality.",
    de: "Das Beste, was Sie online kaufen können! Absolut perfekte Qualität.",
    es: "¡Lo mejor que puedes comprar online! Calidad absolutamente perfecta.",
    fr: "Le meilleur que vous puissiez acheter en ligne ! Qualité absolument parfaite.",
    it: "Il meglio che puoi acquistare online! Qualità assolutamente perfetta.",
    pt: "O melhor que você pode comprar online! Qualidade absolutamente perfeita.",
    ru: "Лучшее, что можно купить в Интернете! Абсолютно идеальное качество.",
    sv: "Det bästa du kan köpa online! Helt perfekt kvalitet.",
    zh: "网上能买到的最好的！绝对完美的品质。",
  },
  17: {
    en: "Everything went fine and fast. The ID card looks very real and helped me a lot!",
    de: "Alles hat gut und schnell geklappt. Der Ausweis sieht sehr echt aus und hat mir sehr geholfen!",
    es: "Todo salió bien y rápido. ¡La tarjeta de identificación parece muy real y me ayudó mucho!",
    fr: "Tout s'est bien passé et rapidement. La carte d'identité a l'air très réelle et m'a beaucoup aidé !",
    it: "Tutto è andato bene e velocemente. La carta d'identità sembra molto reale e mi ha aiutato molto!",
    pt: "Tudo correu bem e rápido. O cartão de identificação parece muito real e me ajudou muito!",
    ru: "Все прошло отлично и быстро. Удостоверение личности выглядит очень реальным и мне очень помогло!",
    sv: "Allt gick bra och snabbt. ID-kortet ser väldigt verkligt ut och hjälpte mig mycket!",
    zh: "一切都进行得又快又好。身份证看起来很真实，对我帮助很大！",
  },
  18: {
    en: "I liked that I was able to go to places with my ID. I like how it looks, too!",
    de: "Mir gefiel, dass ich mit meinem Ausweis an Orte gehen konnte. Mir gefällt auch, wie es aussieht!",
    es: "Me gustó poder ir a lugares con mi identificación. ¡También me gusta cómo se ve!",
    fr: "J'ai aimé pouvoir me rendre dans des endroits avec ma carte d'identité. J'aime aussi à quoi il ressemble !",
    it: "Mi è piaciuto poter andare in posti con la mia carta d'identità. Mi piace anche il suo aspetto!",
    pt: "Gostei de poder ir a lugares com meu documento de identidade. Também gosto da aparência!",
    ru: "Мне понравилось, что я мог ходить в места со своим удостоверением личности. Мне тоже нравится, как он выглядит!",
    sv: "Jag gillade att jag kunde åka till platser med mitt ID. Jag gillar hur det ser ut också!",
    zh: "我很高兴我可以带着身份证去一些地方。我也喜欢它的外观！",
  },
  19: {
    en: "Great provider, fast delivery and good quality! Would recommend to everyone!",
    de: "Toller Anbieter, schnelle Lieferung und gute Qualität! Würde es jedem empfehlen!",
    es: "¡Excelente proveedor, entrega rápida y buena calidad! ¡Se lo recomendaría a todo el mundo!",
    fr: "Excellent fournisseur, livraison rapide et bonne qualité ! Je le recommande à tout le monde !",
    it: "Ottimo fornitore, consegna veloce e buona qualità! Lo consiglio a tutti!",
    pt: "Ótimo fornecedor, entrega rápida e boa qualidade! Recomendo a todos!",
    ru: "Отличный поставщик, быстрая доставка и хорошее качество! Рекомендую всем!",
    sv: "Bra leverantör, snabb leverans och bra kvalitet! Skulle rekommendera till alla!",
    zh: "优秀的供应商，交货快，质量好！会推荐给大家！",
  },
  20: {
    en: "Had a very good experience with the website! Everything worked out great.",
    de: "Hatte eine sehr gute Erfahrung mit der Website! Hat alles super geklappt.",
    es: "¡Tuve una muy buena experiencia con el sitio web! Todo salió muy bien.",
    fr: "J'ai eu une très bonne expérience avec le site Web ! Tout s'est très bien passé.",
    it: "Ho avuto un'esperienza molto positiva con il sito web! Tutto ha funzionato alla grande.",
    pt: "Tive uma experiência muito boa com o site! Tudo funcionou perfeitamente.",
    ru: "Очень понравилось пользоваться сайтом! Все получилось отлично.",
    sv: "Hade en mycket bra upplevelse av webbplatsen! Allt fungerade utmärkt.",
    zh: "该网站的体验非常好！一切都很顺利。",
  },
  21: {
    en: "I'm totally satisfied with the card I ordered - It looks completely real!",
    de: "Ich bin total zufrieden mit der Karte, die ich bestellt habe - Sie sieht absolut echt aus!",
    es: "Estoy totalmente satisfecho con la tarjeta que pedí. ¡Parece completamente real!",
    fr: "Je suis totalement satisfait de la carte que j'ai commandée - Elle a l'air tout à fait réelle !",
    it: "Sono totalmente soddisfatto della carta che ho ordinato: sembra completamente reale!",
    pt: "Estou totalmente satisfeito com o cartão que encomendei. Parece completamente real!",
    ru: "Я полностью доволен заказанной картой - выглядит вполне настоящей!",
    sv: "Jag är helt nöjd med kortet jag beställde - det ser helt äkta ut!",
    zh: "我对我订购的卡片非常满意 - 它看起来完全真实！",
  },
  22: {
    en: "Very reputable! ID came after about a week and the hologram makes it look super real!",
    de: "Sehr seriös! Der Ausweis kam nach etwa einer Woche und durch das Hologramm sieht er super echt aus!",
    es: "¡Muy acreditada! ¡La identificación llegó después de aproximadamente una semana y el holograma hace que parezca súper real!",
    fr: "Très réputé ! La pièce d'identité est arrivée au bout d'environ une semaine et l'hologramme lui donne un aspect super réel !",
    it: "Molto affidabile! Il documento d'identità è arrivato dopo circa una settimana e l'ologramma lo fa sembrare super reale!",
    pt: "Muito confiável! A identificação chegou depois de cerca de uma semana e o holograma faz com que pareça super real!",
    ru: "Очень солидно! ID пришел примерно через неделю, и благодаря голограмме он выглядит очень настоящим!",
    sv: "Mycket ansedda! ID kom efter ungefär en vecka och hologrammet får det att se superäkta ut!",
    zh: "非常有信誉！大约一周后身份证就到了，全息图让它看起来超级真实！",
  },
  23: {
    en: "Fast delivery, good quality! Exactly what I was looking for.",
    de: "Schnelle Lieferung, gute Qualität! Genau das, was ich gesucht habe.",
    es: "¡Entrega rápida, buena calidad! Exactamente lo que estaba buscando.",
    fr: "Livraison rapide, bonne qualité ! Exactement ce que je recherchais.",
    it: "Consegna veloce, buona qualità! Esattamente quello che cercavo.",
    pt: "Entrega rápida, boa qualidade! Exatamente o que eu procurava.",
    ru: "Быстрая доставка, хорошее качество! Именно то, что я искал.",
    sv: "Snabb leverans, bra kvalitet! Precis vad jag letade efter.",
    zh: "交货快，质量好！正是我正在寻找的东西。",
  },
  24: {
    en: "Simply fast! Looks totally real! Top ID quality!",
    de: "Einfach schnell! Sieht absolut echt aus! Top ID-Qualität!",
    es: "¡Simplemente rápido! ¡Parece totalmente real! ¡Máxima calidad de identificación!",
    fr: "Tout simplement rapide ! Ça a l'air totalement réel ! Qualité d'identification supérieure !",
    it: "Semplicemente veloce! Sembra totalmente reale! Massima qualità dell'ID!",
    pt: "Simplesmente rápido! Parece totalmente real! Qualidade de identificação superior!",
    ru: "Просто быстро! Выглядит совершенно реально! Высшее качество!",
    sv: "Helt enkelt snabbt! Ser helt äkta ut! Högsta ID-kvalitet!",
    zh: "非常快！看起来完全真实！顶级 ID 品质！",
  },
  25: {
    en: "Very satisfied! The card exceeded all my expectations.",
    de: "Sehr zufrieden! Die Karte hat alle meine Erwartungen übertroffen.",
    es: "¡Muy satisfecho! La tarjeta superó todas mis expectativas.",
    fr: "Très satisfait ! La carte a dépassé toutes mes attentes.",
    it: "Molto soddisfatto! La carta ha superato tutte le mie aspettative.",
    pt: "Muito satisfeito! O cartão superou todas as minhas expectativas.",
    ru: "Очень доволен! Карта превзошла все мои ожидания.",
    sv: "Mycket nöjd! Kortet överträffade alla mina förväntningar.",
    zh: "非常满意！该卡超出了我的所有预期。",
  },
  26: {
    en: "Easy ordering. Flexible with payment. Fast delivery to the US.",
    de: "Einfache Bestellung. Flexibel bei der Bezahlung. Schnelle Lieferung in die USA.",
    es: "Realización de pedidos fácil. Flexible con el pago. Entrega rápida a EE. UU.",
    fr: "Commande facile. Flexible avec le paiement. Livraison rapide aux États-Unis.",
    it: "Ordinazione semplice. Flessibile con il pagamento. Consegna rapida negli Stati Uniti.",
    pt: "Fácil pedido. Flexível com pagamento. Entrega rápida para os EUA.",
    ru: "Легкий заказ. Гибкая оплата. Быстрая доставка в США.",
    sv: "Lätt att beställa. Flexibel med betalning. Snabb leverans till USA.",
    zh: "轻松订购。付款方式灵活。快速交付到美国。",
  },
  27: {
    en: "Quality of the card is really great, even the hologram. Superior construction! Delivery was very fast.",
    de: "Die Qualität der Karte ist wirklich großartig, sogar das Hologramm. Überlegene Konstruktion! Die Lieferung erfolgte sehr schnell.",
    es: "La calidad de la tarjeta es realmente excelente, incluso el holograma. ¡Construcción superior! La entrega fue muy rápida.",
    fr: "La qualité de la carte est vraiment excellente, même l'hologramme. Construction supérieure! La livraison a été très rapide.",
    it: "La qualità della carta è davvero ottima, anche l'ologramma. Costruzione superiore! La consegna è stata molto veloce.",
    pt: "A qualidade do cartão é realmente ótima, até mesmo o holograma. Construção superior! A entrega foi muito rápida.",
    ru: "Качество карты действительно отличное, даже голограмма. Превосходная конструкция! Доставка была очень быстрой.",
    sv: "Kvaliteten på kortet är riktigt bra, även hologrammet. Överlägsen konstruktion! Leveransen var mycket snabb.",
    zh: "卡片的质量非常好，甚至是全息图。施工优越！交货非常快。",
  },
  28: {
    en: "Super fast shipment abroad. I am very satisfied with the product, totally happy!",
    de: "Super schneller Versand ins Ausland. Ich bin sehr zufrieden mit dem Produkt, total glücklich!",
    es: "Envío súper rápido al extranjero. ¡Estoy muy satisfecho con el producto, totalmente feliz!",
    fr: "Envoi super rapide à l'étranger. Je suis très satisfaite du produit, totalement content !",
    it: "Spedizione super veloce all'estero. Sono molto soddisfatto del prodotto, totalmente felice!",
    pt: "Envio super rápido para o exterior. Estou muito satisfeito com o produto, totalmente feliz!",
    ru: "Супер быстрая отправка за границу. Я очень доволен товаром, полностью доволен!",
    sv: "Supersnabb leverans utomlands. Jag är mycket nöjd med produkten, helt nöjd!",
    zh: "国外发货超快。我对产品非常满意，非常高兴！",
  },
  29: {
    en: "Very authentic card! I am totally satisfied and can only recommend this website.",
    de: "Sehr authentische Karte! Ich bin rundum zufrieden und kann diese Website nur weiterempfehlen.",
    es: "¡Tarjeta muy auténtica! Estoy totalmente satisfecho y sólo puedo recomendar este sitio web.",
    fr: "Carte très authentique ! Je suis totalement satisfait et ne peux que recommander ce site.",
    it: "Carta molto autentica! Sono totalmente soddisfatto e posso solo consigliare questo sito web.",
    pt: "Cartão muito autêntico! Estou totalmente satisfeito e só posso recomendar este site.",
    ru: "Очень настоящая открытка! Я полностью доволен и могу только рекомендовать этот сайт.",
    sv: "Mycket äkta kort! Jag är helt nöjd och kan bara rekommendera denna webbplats.",
    zh: "非常正宗的卡！我非常满意，只能推荐这个网站。",
  },
  30: {
    en: "Very clean work! Professional quality all around.",
    de: "Sehr saubere Arbeit! Rundum professionelle Qualität.",
    es: "¡Trabajo muy limpio! Calidad profesional en todos los aspectos.",
    fr: "Travail très propre ! Qualité professionnelle à tous points de vue.",
    it: "Lavoro molto pulito! Qualità professionale a tutto tondo.",
    pt: "Trabalho muito limpo! Qualidade profissional em todos os aspectos.",
    ru: "Очень чистая работа! Профессиональное качество во всем.",
    sv: "Mycket rent arbete! Professionell kvalitet överallt.",
    zh: "非常干净的工作！专业品质无处不在。",
  },
  31: {
    en: "Just great! Fast delivery and very good item. Works without any problems. Can't ask for more!",
    de: "Einfach toll! Schnelle Lieferung und sehr guter Artikel. Funktioniert ohne Probleme. Mehr kann man nicht verlangen!",
    es: "¡Simplemente genial! Entrega rápida y muy buen artículo. Funciona sin ningún problema. ¡No puedo pedir más!",
    fr: "Tout simplement génial ! Livraison rapide et très bon article. Fonctionne sans aucun problème. Je ne peux pas demander plus !",
    it: "Semplicemente fantastico! Consegna veloce e articolo molto buono. Funziona senza problemi. Non posso chiedere di più!",
    pt: "Simplesmente ótimo! Entrega rápida e item muito bom. Funciona sem problemas. Não posso pedir mais!",
    ru: "Просто великолепно! Быстрая доставка и очень хороший товар. Работает без проблем. Не могу просить большего!",
    sv: "Bara bra! Snabb leverans och mycket bra vara. Fungerar utan problem. Kan inte begära mer!",
    zh: "太棒了！交货快，物品非常好。工作没有任何问题。不能要求更多！",
  },
  32: {
    en: "At first I was skeptical. But I received the ID card fast and it looks real with the hologram, very professional.",
    de: "Zuerst war ich skeptisch. Aber ich habe den Ausweis schnell erhalten und er sieht mit dem Hologramm echt aus, sehr professionell.",
    es: "Al principio era escéptico. Pero recibí la tarjeta de identificación rápidamente y parece real con el holograma, muy profesional.",
    fr: "Au début, j'étais sceptique. Mais j'ai reçu la carte d'identité rapidement et elle a l'air réelle avec l'hologramme, très professionnel.",
    it: "All'inizio ero scettico. Ma ho ricevuto la carta d'identità velocemente e sembra reale con l'ologramma, molto professionale.",
    pt: "No começo eu estava cético. Mas recebi a carteira de identidade rapidamente e parece real com o holograma, muito profissional.",
    ru: "Сначала я был настроен скептически. Но я получил удостоверение личности быстро, и с голограммой оно выглядит настоящим, очень профессионально.",
    sv: "Först var jag skeptisk. Men jag fick ID-kortet snabbt och det ser riktigt ut med hologrammet, väldigt professionellt.",
    zh: "起初我很怀疑。不过我很快就收到了身份证，而且全息图看起来很真实，非常专业。",
  },
  33: {
    en: "Simply the best! Super quality, fast delivery and fair prices!",
    de: "Einfach das Beste! Super Qualität, schnelle Lieferung und faire Preise!",
    es: "¡Simplemente lo mejor! ¡Súper calidad, entrega rápida y precios justos!",
    fr: "Tout simplement le meilleur ! Super qualité, livraison rapide et prix équitables !",
    it: "Semplicemente il migliore! Qualità eccellente, consegna veloce e prezzi equi!",
    pt: "Simplesmente o melhor! Super qualidade, entrega rápida e preços justos!",
    ru: "Просто лучшее! Супер качество, быстрая доставка и справедливые цены!",
    sv: "Helt enkelt bäst! Superkvalitet, snabb leverans och rimliga priser!",
    zh: "简直是最好的！品质优良，交货快捷，价格公道！",
  },
  34: {
    en: "The ID looks totally real and delivery to the US took only 5 days. I can only recommend them!",
    de: "Der Ausweis sieht absolut echt aus und die Lieferung in die USA dauerte nur 5 Tage. Ich kann sie nur empfehlen!",
    es: "La identificación parece totalmente real y la entrega a los EE. UU. tomó solo 5 días. ¡Solo puedo recomendarlos!",
    fr: "La pièce d'identité semble totalement réelle et la livraison aux États-Unis n'a pris que 5 jours. Je ne peux que les recommander !",
    it: "L'ID sembra totalmente reale e la consegna negli Stati Uniti ha richiesto solo 5 giorni. Non posso che consigliarli!",
    pt: "O ID parece totalmente real e a entrega nos EUA demorou apenas 5 dias. Só posso recomendá-los!",
    ru: "Удостоверение выглядит абсолютно реальным, а доставка в США заняла всего 5 дней. Могу только рекомендовать!",
    sv: "ID:t ser helt äkta ut och leveransen till USA tog bara 5 dagar. Jag kan bara rekommendera dem!",
    zh: "ID 看起来完全真实，并且仅用 5 天就送到美国。我只能推荐它们！",
  },
  35: {
    en: "The card looks totally real, I'm thrilled! The order came fast and smooth, just after 2 days!",
    de: "Die Karte sieht absolut echt aus, ich bin begeistert! Die Bestellung kam schnell und reibungslos, schon nach 2 Tagen!",
    es: "La tarjeta parece totalmente real, ¡estoy encantado! ¡El pedido llegó rápido y sin problemas, justo después de 2 días!",
    fr: "La carte a l'air totalement réelle, je suis ravie ! La commande est arrivée rapidement et sans problème, juste après 2 jours !",
    it: "La card sembra totalmente reale, sono entusiasta! L'ordine è arrivato velocemente e senza intoppi, appena dopo 2 giorni!",
    pt: "O cartão parece totalmente real, estou emocionado! O pedido chegou rápido e tranquilo, logo depois de 2 dias!",
    ru: "Открытка выглядит совершенно настоящей, я в восторге! Заказ пришел быстро и без проблем, всего за 2 дня!",
    sv: "Kortet ser helt äkta ut, jag är överlycklig! Beställningen kom snabbt och smidigt, strax efter 2 dagar!",
    zh: "这张卡片看起来完全真实，我很兴奋！订单快速顺利，仅用了2天！",
  },
  36: {
    en: "Super fast shipping to the United States, thank you!!",
    de: "Super schneller Versand in die Vereinigten Staaten, vielen Dank!!",
    es: "¡Envío súper rápido a los Estados Unidos, gracias!",
    fr: "Expédition super rapide aux États-Unis, merci !!",
    it: "Spedizione super veloce negli Stati Uniti, grazie!!",
    pt: "Envio super rápido para os Estados Unidos, obrigado!!",
    ru: "Супер быстрая доставка в США, спасибо!!",
    sv: "Supersnabb leverans till USA, tack!!",
    zh: "超快的运输到美国，谢谢！",
  },
  37: {
    en: "Fast delivery, easy settlement. Everything as it should be.",
    de: "Schnelle Lieferung, einfache Abwicklung. Alles wie es sein soll.",
    es: "Entrega rápida, fácil solución. Todo como debería ser.",
    fr: "Livraison rapide, règlement facile. Tout comme il se doit.",
    it: "Consegna veloce, pagamento facile. Tutto come dovrebbe essere.",
    pt: "Entrega rápida, liquidação fácil. Tudo como deveria estar.",
    ru: "Быстрая доставка, простой расчет. Все как положено.",
    sv: "Snabb leverans, enkel betalning. Allt som det ska vara.",
    zh: "快速交货，轻松结算。一切都应该如此。",
  },
  38: {
    en: "Fast delivery, very good quality! Top!",
    de: "Schnelle Lieferung, sehr gute Qualität! Top!",
    es: "Entrega rápida, ¡muy buena calidad! ¡Arriba!",
    fr: "Livraison rapide, très bonne qualité ! Top !",
    it: "Consegna veloce, ottima qualità! Ottimo!",
    pt: "Entrega rápida, qualidade muito boa! Top!",
    ru: "Быстрая доставка, очень хорошее качество! Топ!",
    sv: "Snabb leverans, mycket bra kvalitet! Toppen!",
    zh: "交货快，质量非常好！顶！",
  },
  39: {
    en: "Super fast delivery. I was totally excited and it was exactly what I imagined. Would buy again!",
    de: "Super schnelle Lieferung. Ich war total begeistert und es war genau das, was ich mir vorgestellt habe. Würde wieder kaufen!",
    es: "Entrega súper rápida. Estaba totalmente emocionado y era exactamente lo que imaginaba. ¡Lo compraría de nuevo!",
    fr: "Livraison super rapide. J’étais totalement excité et c’était exactement ce que j’imaginais. J'achèterais à nouveau !",
    it: "Consegna super veloce. Ero totalmente emozionato ed era esattamente quello che immaginavo. La comprerei di nuovo!",
    pt: "Entrega super rápida. Fiquei totalmente emocionado e foi exatamente o que imaginei. Compraria novamente!",
    ru: "Супер быстрая доставка. Я был полностью взволнован, и это было именно то, что я себе представлял. Купил бы снова!",
    sv: "Supersnabb leverans. Jag var helt exalterad och det var precis vad jag föreställde mig. Skulle köpa igen!",
    zh: "交货速度超快。我非常兴奋，这正是我想象的。会再次购买！",
  },
  40: {
    en: "Super card, looks perfect and deceptively real. Even the photo has been integrated very well.",
    de: "Super Karte, sieht perfekt und täuschend echt aus. Sogar das Foto wurde sehr gut integriert.",
    es: "Súper tarjeta, se ve perfecta y engañosamente real. Incluso la foto se ha integrado muy bien.",
    fr: "Super carte, semble parfaite et trompeusement réelle. Même la photo a été très bien intégrée.",
    it: "Super carta, sembra perfetta e ingannevolmente reale. Anche la foto è stata integrata molto bene.",
    pt: "Super cartão, parece perfeito e enganosamente real. Até a foto foi muito bem integrada.",
    ru: "Суперкарта, выглядит идеально и обманчиво реалистично. Даже фотография интегрирована очень хорошо.",
    sv: "Superkort, ser perfekt ut och bedrägligt äkta. Även fotot har integrerats mycket bra.",
    zh: "超级卡片，看起来完美且看似真实。连照片都整合得很好。",
  },
  41: {
    en: "Fast and discrete! Exactly what I needed.",
    de: "Schnell und diskret! Genau das, was ich brauchte.",
    es: "¡Rápido y discreto! Exactamente lo que necesitaba.",
    fr: "Rapide et discret ! Exactement ce dont j'avais besoin.",
    it: "Veloce e discreto! Esattamente quello di cui avevo bisogno.",
    pt: "Rápido e discreto! Exatamente o que eu precisava.",
    ru: "Быстро и дискретно! Именно то, что мне нужно.",
    sv: "Snabbt och diskret! Precis vad jag behövde.",
    zh: "快速而离散！正是我需要的。",
  },
  42: {
    en: "Very fast delivery - Top Product! Highly recommended.",
    de: "Sehr schnelle Lieferung - Top Produkt! Sehr zu empfehlen.",
    es: "Entrega muy rápida: ¡producto superior! Altamente recomendado.",
    fr: "Livraison très rapide - Top produit ! Fortement recommandé.",
    it: "Consegna molto veloce - Prodotto top! Altamente raccomandato.",
    pt: "Entrega muito rápida - Produto Top! Altamente recomendado.",
    ru: "Очень быстрая доставка – лучший продукт! Настоятельно рекомендуется.",
    sv: "Mycket snabb leverans - Toppprodukt! Rekommenderas varmt.",
    zh: "交货非常快 - 顶级产品！强烈推荐。",
  },
  43: {
    en: "Great products! Fast shipping! Trustworthy service!",
    de: "Tolle Produkte! Schneller Versand! Vertrauenswürdiger Service!",
    es: "¡Excelentes productos! ¡Envío rápido! ¡Servicio confiable!",
    fr: "Excellents produits ! Expédition rapide! Service digne de confiance !",
    it: "Ottimi prodotti! Spedizione veloce! Servizio affidabile!",
    pt: "Ótimos produtos! Envio rápido! Serviço confiável!",
    ru: "Отличная продукция! Быстрая доставка! Надежный сервис!",
    sv: "Bra produkter! Snabb leverans! Pålitlig service!",
    zh: "很棒的产品！发货快！值得信赖的服务！",
  },
  44: {
    en: "This is a great website and I can only recommend it to everyone!",
    de: "Das ist eine tolle Website und ich kann sie nur jedem empfehlen!",
    es: "¡Este es un excelente sitio web y solo puedo recomendarlo a todos!",
    fr: "C'est un excellent site Web et je ne peux que le recommander à tout le monde !",
    it: "Questo è un ottimo sito web e posso solo consigliarlo a tutti!",
    pt: "Este é um ótimo site e só posso recomendá-lo a todos!",
    ru: "Это отличный веб-сайт, и я могу только рекомендовать его всем!",
    sv: "Det här är en fantastisk webbplats och jag kan bara rekommendera den till alla!",
    zh: "这是一个很棒的网站，我只能推荐给大家！",
  },
  45: {
    en: "Top quality, fair prices, very fast delivery time. Perfect!",
    de: "Top-Qualität, faire Preise, sehr schnelle Lieferzeit. Perfekt!",
    es: "Calidad superior, precios justos y tiempo de entrega muy rápido. ¡Perfecto!",
    fr: "Qualité supérieure, prix équitables, délai de livraison très rapide. Parfait !",
    it: "Alta qualità, prezzi equi, tempi di consegna molto rapidi. Perfetto!",
    pt: "Qualidade máxima, preços justos, prazo de entrega muito rápido. Perfeito!",
    ru: "Высочайшее качество, разумные цены, очень быстрые сроки доставки. Отлично!",
    sv: "Högsta kvalitet, rimliga priser, mycket snabb leveranstid. Perfekt!",
    zh: "一流的质量，公平的价格，非常快的交货时间。完美！",
  },
  46: {
    en: "On time and perfect! Just love it!",
    de: "Pünktlich und perfekt! Ich liebe es einfach!",
    es: "¡A tiempo y perfecto! ¡Me encanta!",
    fr: "À l'heure et parfait ! J'adore ça !",
    it: "Puntuali e perfetti! Lo adoro!",
    pt: "Na hora certa e perfeito! Simplesmente adorei!",
    ru: "Вовремя и идеально! Просто в восторге!",
    sv: "I tid och perfekt! Bara älskar det!",
    zh: "准时且完美！就是喜欢它！",
  },
  47: {
    en: "Everything worked smoothly. The delivery was very fast!",
    de: "Alles hat reibungslos funktioniert. Die Lieferung erfolgte sehr schnell!",
    es: "Todo funcionó sin problemas. ¡La entrega fue muy rápida!",
    fr: "Tout s'est bien passé. La livraison a été très rapide !",
    it: "Tutto ha funzionato perfettamente. La consegna è stata molto veloce!",
    pt: "Tudo funcionou perfeitamente. A entrega foi muito rápida!",
    ru: "Все работало гладко. Доставка была очень быстрой!",
    sv: "Allt fungerade smidigt. Leveransen var mycket snabb!",
    zh: "一切都很顺利。交货速度非常快！",
  },
  48: {
    en: "Very pleased with the rapid settlement of my order! Very satisfied with the service and overall performance.",
    de: "Sehr zufrieden mit der schnellen Abwicklung meiner Bestellung! Sehr zufrieden mit dem Service und der Gesamtleistung.",
    es: "¡Muy satisfecho con la rápida liquidación de mi pedido! Muy satisfecho con el servicio y el rendimiento general.",
    fr: "Très satisfait du règlement rapide de ma commande ! Très satisfait du service et des performances globales.",
    it: "Molto soddisfatto della rapida liquidazione del mio ordine! Molto soddisfatto del servizio e delle prestazioni complessive.",
    pt: "Muito satisfeito com a rápida liquidação do meu pedido! Muito satisfeito com o serviço e desempenho geral.",
    ru: "Очень доволен быстрым выполнением моего заказа! Очень доволен обслуживанием и общей производительностью.",
    sv: "Mycket nöjd med den snabba avvecklingen av min beställning! Mycket nöjd med servicen och övergripande prestanda.",
    zh: "对我的订单快速结算感到非常满意！对服务和整体表现非常满意。",
  },
  49: {
    en: "Easy ordering, fast delivery, good customer service - always happy!",
    de: "Einfache Bestellung, schnelle Lieferung, guter Kundenservice – immer zufrieden!",
    es: "Realización de pedidos sencilla, entrega rápida, buen servicio al cliente. ¡Siempre feliz!",
    fr: "Commande facile, livraison rapide, bon service client - toujours heureux !",
    it: "Ordinazione semplice, consegna veloce, buon servizio clienti: sempre felice!",
    pt: "Fácil pedido, entrega rápida, bom atendimento ao cliente - sempre satisfeito!",
    ru: "Легкий заказ, быстрая доставка, хорошее обслуживание клиентов — всегда доволен!",
    sv: "Lätt att beställa, snabb leverans, bra kundservice - alltid nöjd!",
    zh: "订购方便，交货快捷，良好的客户服务 - 永远开心！",
  },
  50: {
    en: "Best fake ID service I have ever used. Will definitely order again!",
    de: "Bester gefälschter Ausweisservice, den ich je genutzt habe. Werde auf jeden Fall wieder bestellen!",
    es: "El mejor servicio de identificación falsa que he usado. ¡Definitivamente haré el pedido nuevamente!",
    fr: "Le meilleur service de fausses pièces d'identité que j'ai jamais utilisé. Je commanderai certainement à nouveau !",
    it: "Il miglior servizio di documenti falsi che abbia mai utilizzato. Lo ordinerò sicuramente di nuovo!",
    pt: "Melhor serviço de identidade falsa que já usei. Com certeza pedirei novamente!",
    ru: "Лучший сервис по подделке удостоверений личности, которым я когда-либо пользовался. Обязательно закажу еще!",
    sv: "Bästa falska ID-tjänst jag någonsin använt. Kommer definitivt att beställa igen!",
    zh: "我用过的最好的假身份证服务。一定会再次订购！",
  },
  51: {
    en: "Perfect for my themed party. Everyone was impressed with the quality.",
    de: "Perfekt für meine Mottoparty. Alle waren von der Qualität beeindruckt.",
    es: "Perfecto para mi fiesta temática. Todos quedaron impresionados con la calidad.",
    fr: "Parfait pour ma soirée à thème. Tout le monde a été impressionné par la qualité.",
    it: "Perfetto per la mia festa a tema. Tutti sono rimasti colpiti dalla qualità.",
    pt: "Perfeito para minha festa temática. Todos ficaram impressionados com a qualidade.",
    ru: "Идеально для моей тематической вечеринки. Качество всех впечатлило.",
    sv: "Perfekt för min temafest. Alla var imponerade av kvaliteten.",
    zh: "非常适合我的主题派对。每个人都对质量印象深刻。",
  },
  52: {
    en: "Ordered 10 cards for our team event. All came out perfect!",
    de: "Habe 10 Karten für unser Teamevent bestellt. Alles ist perfekt gelaufen!",
    es: "Pedí 10 tarjetas para el evento de nuestro equipo. ¡Todo salió perfecto!",
    fr: "J'ai commandé 10 cartes pour notre événement d'équipe. Tout est parfait !",
    it: "Ho ordinato 10 cartoline per il nostro evento di squadra. Tutto è venuto perfetto!",
    pt: "Encomendei 10 cartões para o evento da nossa equipe. Tudo saiu perfeito!",
    ru: "Заказали 10 карточек для нашего командного мероприятия. Все получилось идеально!",
    sv: "Beställde 10 kort för vårt lagevenemang. Allt blev perfekt!",
    zh: "为我们的团队活动订购了 10 张卡片。一切都很完美！",
  },
  53: {
    en: "Good quality and fast shipping. Very professional.",
    de: "Gute Qualität und schneller Versand. Sehr professionell.",
    es: "Buena calidad y envío rápido. Muy profesional.",
    fr: "Bonne qualité et expédition rapide. Très professionnel.",
    it: "Buona qualità e spedizione veloce. Molto professionale.",
    pt: "Boa qualidade e envio rápido. Muito profissional.",
    ru: "Хорошее качество и быстрая доставка. Очень профессионально.",
    sv: "Bra kvalitet och snabb leverans. Mycket professionellt.",
    zh: "质量好，运输快。非常专业。",
  },
  54: {
    en: "I love it! Perfect in every way.",
    de: "Ich liebe es! Perfekt in jeder Hinsicht.",
    es: "¡Me encanta! Perfecto en todos los sentidos.",
    fr: "J'adore ça ! Parfait à tous points de vue.",
    it: "Lo adoro! Perfetto in ogni modo.",
    pt: "Adorei! Perfeito em todos os sentidos.",
    ru: "Мне это нравится! Идеален во всех отношениях.",
    sv: "Jag älskar det! Perfekt på alla sätt.",
    zh: "我喜欢！各方面都很完美。",
  },
  55: {
    en: "Perfect! Exceeded all my expectations.",
    de: "Perfekt! Hat alle meine Erwartungen übertroffen.",
    es: "¡Perfecto! Superó todas mis expectativas.",
    fr: "Parfait ! A dépassé toutes mes attentes.",
    it: "Perfetto! Ha superato tutte le mie aspettative.",
    pt: "Perfeito! Superou todas as minhas expectativas.",
    ru: "Идеален! Превзошел все мои ожидания.",
    sv: "Perfekt! Överträffade alla mina förväntningar.",
    zh: "完美！超出了我的所有期望。",
  },
  56: {
    en: "Very happy with my purchase. The customization options are great.",
    de: "Sehr zufrieden mit meinem Kauf. Die Anpassungsmöglichkeiten sind großartig.",
    es: "Muy contento con mi compra. Las opciones de personalización son geniales.",
    fr: "Très content de mon achat. Les options de personnalisation sont excellentes.",
    it: "Molto soddisfatto del mio acquisto. Le opzioni di personalizzazione sono fantastiche.",
    pt: "Muito feliz com minha compra. As opções de personalização são ótimas.",
    ru: "Очень доволен покупкой. Возможности персонализации отличные.",
    sv: "Mycket nöjd med mitt köp. Anpassningsalternativen är fantastiska.",
    zh: "对我的购买非常满意。定制选项很棒。",
  },
  57: {
    en: "Good service, fast shipping to Europe. Minor delay but worth the wait.",
    de: "Guter Service, schneller Versand nach Europa. Kleine Verzögerung, aber das Warten hat sich gelohnt.",
    es: "Buen servicio, envío rápido a Europa. Retraso menor pero vale la pena esperar.",
    fr: "Bon service, expédition rapide vers l'Europe. Retard mineur mais ça vaut le coup d'attendre.",
    it: "Buon servizio, spedizione veloce in Europa. Piccolo ritardo ma vale la pena aspettare.",
    pt: "Bom atendimento, envio rápido para a Europa. Pequeno atraso, mas vale a pena esperar.",
    ru: "Хорошее обслуживание, быстрая доставка в Европу. Небольшая задержка, но ожидание того стоит.",
    sv: "Bra service, snabb leverans till Europa. Mindre förseningar men värt att vänta.",
    zh: "良好的服务，快速运送到欧洲。略有延迟，但值得等待。",
  },
  58: {
    en: "Great quality overall. Shipping took a bit longer than expected but the result was worth it.",
    de: "Tolle Qualität insgesamt. Der Versand hat etwas länger gedauert als erwartet, aber das Ergebnis hat sich gelohnt.",
    es: "Gran calidad en general. El envío tardó un poco más de lo esperado pero el resultado valió la pena.",
    fr: "Excellente qualité dans l'ensemble. L'expédition a pris un peu plus de temps que prévu mais le résultat en valait la peine.",
    it: "Ottima qualità nel complesso. La spedizione ha richiesto un po' più tempo del previsto ma ne è valsa la pena.",
    pt: "Ótima qualidade geral. O envio demorou um pouco mais do que o esperado, mas o resultado valeu a pena.",
    ru: "В целом качество отличное. Доставка заняла немного больше времени, чем ожидалось, но результат того стоил.",
    sv: "Bra kvalitet överlag. Frakten tog lite längre tid än förväntat men resultatet var värt det.",
    zh: "总体质量很好。运输时间比预期要长一些，但结果是值得的。",
  },
  59: {
    en: "Nice card, good quality. Customer support was helpful when I had questions.",
    de: "Schöne Karte, gute Qualität. Der Kundensupport war hilfreich, wenn ich Fragen hatte.",
    es: "Bonita tarjeta, buena calidad. La atención al cliente fue útil cuando tenía preguntas.",
    fr: "Belle carte, bonne qualité. Le support client m'a été utile lorsque j'avais des questions.",
    it: "Bella carta, di buona qualità. L'assistenza clienti è stata utile quando avevo domande.",
    pt: "Bonito cartão, de boa qualidade. O suporte ao cliente foi útil quando tive dúvidas.",
    ru: "Хорошая карта, хорошего качества. Служба поддержки помогла, когда у меня возникли вопросы.",
    sv: "Snyggt kort, bra kvalitet. Kundsupporten var till hjälp när jag hade frågor.",
    zh: "卡片不错，质量很好。当我有疑问时，客户支持很有帮助。",
  },
  60: {
    en: "Solid product, exactly as described. Would have given 5 stars but delivery was slightly delayed.",
    de: "Solides Produkt, genau wie beschrieben. Hätte 5 Sterne gegeben, aber die Lieferung verzögerte sich leicht.",
    es: "Producto sólido, exactamente como se describe. Le habría dado 5 estrellas pero la entrega se retrasó ligeramente.",
    fr: "Produit solide, exactement comme décrit. J'aurais donné 5 étoiles mais la livraison a été légèrement retardée.",
    it: "Prodotto solido, esattamente come descritto. Avrei dato 5 stelle ma la consegna è stata leggermente ritardata.",
    pt: "Produto sólido, exatamente como descrito. Teria dado 5 estrelas, mas a entrega atrasou um pouco.",
    ru: "Надежный продукт, точно соответствует описанию. Поставил бы 5 звезд, но доставка немного задержалась.",
    sv: "Solid produkt, exakt enligt beskrivningen. Skulle ha gett 5 stjärnor men leveransen blev något försenad.",
    zh: "可靠的产品，与描述的完全一致。本来可以给 5 颗星，但交货略有延迟。",
  },
};

const locationTranslations: Record<string, Record<TestimonialLanguage, string>> = {
  "Albania": {
    en: "Albania",
    de: "Albanien",
    es: "Albania",
    fr: "Albanie",
    it: "Albania",
    pt: "Albânia",
    ru: "Албания",
    sv: "Albanien",
    zh: "阿尔巴尼亚",
  },
  "Argentina": {
    en: "Argentina",
    de: "Argentinien",
    es: "Argentina",
    fr: "Argentine",
    it: "Argentina",
    pt: "Argentina",
    ru: "Аргентина",
    sv: "Argentina",
    zh: "阿根廷",
  },
  "Australia": {
    en: "Australia",
    de: "Australien",
    es: "Australia",
    fr: "Australie",
    it: "Australia",
    pt: "Austrália",
    ru: "Австралия",
    sv: "Australien",
    zh: "澳大利亚",
  },
  "Austria": {
    en: "Austria",
    de: "Österreich",
    es: "Austria",
    fr: "Autriche",
    it: "Austria",
    pt: "Áustria",
    ru: "Австрия",
    sv: "Österrike",
    zh: "奥地利",
  },
  "Belgium": {
    en: "Belgium",
    de: "Belgien",
    es: "Bélgica",
    fr: "Belgique",
    it: "Belgio",
    pt: "Bélgica",
    ru: "Бельгия",
    sv: "Belgien",
    zh: "比利时",
  },
  "Bosnia": {
    en: "Bosnia",
    de: "Bosnien",
    es: "Bosnia",
    fr: "Bosnie",
    it: "Bosnia",
    pt: "Bósnia",
    ru: "Босния",
    sv: "Bosnien",
    zh: "波斯尼亚",
  },
  "Brazil": {
    en: "Brazil",
    de: "Brasilien",
    es: "Brasil",
    fr: "Brésil",
    it: "Brasile",
    pt: "Brasil",
    ru: "Бразилия",
    sv: "Brasilien",
    zh: "巴西",
  },
  "Bulgaria": {
    en: "Bulgaria",
    de: "Bulgarien",
    es: "Bulgaria",
    fr: "Bulgarie",
    it: "Bulgaria",
    pt: "Bulgária",
    ru: "Болгария",
    sv: "Bulgarien",
    zh: "保加利亚",
  },
  "Canada": {
    en: "Canada",
    de: "Kanada",
    es: "Canadá",
    fr: "Canada",
    it: "Canada",
    pt: "Canadá",
    ru: "Канада",
    sv: "Kanada",
    zh: "加拿大",
  },
  "France": {
    en: "France",
    de: "Frankreich",
    es: "Francia",
    fr: "France",
    it: "Francia",
    pt: "França",
    ru: "Франция",
    sv: "Frankrike",
    zh: "法国",
  },
  "Germany": {
    en: "Germany",
    de: "Deutschland",
    es: "Alemania",
    fr: "Allemagne",
    it: "Germania",
    pt: "Alemanha",
    ru: "Германия",
    sv: "Tyskland",
    zh: "德国",
  },
  "Greece": {
    en: "Greece",
    de: "Griechenland",
    es: "Grecia",
    fr: "Grèce",
    it: "Grecia",
    pt: "Grécia",
    ru: "Греция",
    sv: "Grekland",
    zh: "希腊",
  },
  "Iran": {
    en: "Iran",
    de: "Iran",
    es: "Irán",
    fr: "Iran",
    it: "Iran",
    pt: "Irã",
    ru: "Иран",
    sv: "Iran",
    zh: "伊朗",
  },
  "Ireland": {
    en: "Ireland",
    de: "Irland",
    es: "Irlanda",
    fr: "Irlande",
    it: "Irlanda",
    pt: "Irlanda",
    ru: "Ирландия",
    sv: "Irland",
    zh: "爱尔兰",
  },
  "Italy": {
    en: "Italy",
    de: "Italien",
    es: "Italia",
    fr: "Italie",
    it: "Italia",
    pt: "Itália",
    ru: "Италия",
    sv: "Italien",
    zh: "意大利",
  },
  "Kosovo": {
    en: "Kosovo",
    de: "Ko sovo",
    es: "Ko sovo",
    fr: "Ko sovo",
    it: "Ko sovo",
    pt: "Ko sovo",
    ru: "Ко sovo",
    sv: "Ko sovo",
    zh: "科索沃",
  },
  "Latvia": {
    en: "Latvia",
    de: "Lettland",
    es: "Letonia",
    fr: "Lettonie",
    it: "Lettonia",
    pt: "Letônia",
    ru: "Латвия",
    sv: "Lettland",
    zh: "拉脱维亚",
  },
  "Mexico": {
    en: "Mexico",
    de: "Mexiko",
    es: "México",
    fr: "Mexique",
    it: "Messico",
    pt: "México",
    ru: "Мексика",
    sv: "Mexiko",
    zh: "墨西哥",
  },
  "Morocco": {
    en: "Morocco",
    de: "Marokko",
    es: "Marruecos",
    fr: "Maroc",
    it: "Marocco",
    pt: "Marrocos",
    ru: "Марокко",
    sv: "Marocko",
    zh: "摩洛哥",
  },
  "Netherlands": {
    en: "Netherlands",
    de: "Niederlande",
    es: "Países Bajos",
    fr: "Pays-Bas",
    it: "Paesi Bassi",
    pt: "Holanda",
    ru: "Нидерланды",
    sv: "Nederländerna",
    zh: "荷兰",
  },
  "Norway": {
    en: "Norway",
    de: "Norwegen",
    es: "Noruega",
    fr: "Norvège",
    it: "Norvegia",
    pt: "Noruega",
    ru: "Норвегия",
    sv: "Norge",
    zh: "挪威",
  },
  "Poland": {
    en: "Poland",
    de: "Polen",
    es: "Polonia",
    fr: "Pologne",
    it: "Polonia",
    pt: "Polônia",
    ru: "Польша",
    sv: "Polen",
    zh: "波兰",
  },
  "Portugal": {
    en: "Portugal",
    de: "Por tugal",
    es: "Por tugal",
    fr: "Por Tugal",
    it: "Por tugalo",
    pt: "Por tugal",
    ru: "Пор тугал",
    sv: "Por tugal",
    zh: "葡萄牙图加尔",
  },
  "Russia": {
    en: "Russia",
    de: "Russland",
    es: "Rusia",
    fr: "Russie",
    it: "Russia",
    pt: "Rússia",
    ru: "Россия",
    sv: "Ryssland",
    zh: "俄罗斯",
  },
  "Spain": {
    en: "Spain",
    de: "Spanien",
    es: "España",
    fr: "Espagne",
    it: "Spagna",
    pt: "Espanha",
    ru: "Испания",
    sv: "Spanien",
    zh: "西班牙",
  },
  "Sweden": {
    en: "Sweden",
    de: "Schweden",
    es: "Suecia",
    fr: "Suède",
    it: "Svezia",
    pt: "Suécia",
    ru: "Швеция",
    sv: "Sverige",
    zh: "瑞典",
  },
  "Switzerland": {
    en: "Switzerland",
    de: "Schweiz",
    es: "Suiza",
    fr: "Suisse",
    it: "Svizzera",
    pt: "Suíça",
    ru: "Швейцария",
    sv: "Schweiz",
    zh: "瑞士",
  },
  "Turkey": {
    en: "Turkey",
    de: "Türkei",
    es: "Turquía",
    fr: "Turquie",
    it: "Turchia",
    pt: "Turquia",
    ru: "Турция",
    sv: "Turkiet",
    zh: "土耳其",
  },
  "UK": {
    en: "UK",
    de: "Großbritannien",
    es: "Reino Unido",
    fr: "Royaume-Uni",
    it: "Regno Unito",
    pt: "Reino Unido",
    ru: "Великобритания",
    sv: "Storbritannien",
    zh: "英国",
  },
  "USA": {
    en: "USA",
    de: "USA",
    es: "Estados Unidos",
    fr: "États-Unis",
    it: "USA",
    pt: "EUA",
    ru: "США",
    sv: "USA",
    zh: "美国",
  },
};

function localizeReview(review: Testimonial, language: TestimonialLanguage): Testimonial {
  return {
    ...review,
    text: testimonialTextTranslations[review.id]?.[language] || testimonialTextTranslations[review.id]?.en || review.text,
    location: locationTranslations[review.location]?.[language] || locationTranslations[review.location]?.en || review.location,
  };
}

export function getLocalizedTestimonials(language: TestimonialLanguage): Testimonial[] {
  return testimonials.map((review) => localizeReview(review, language));
}

export function getLocalizedExtendedReviews(language: TestimonialLanguage): Testimonial[] {
  return extendedReviews.map((review) => localizeReview(review, language));
}